import React from 'react';

// Utils
import { useTranslation } from 'react-i18next';
import withAuth from '../../../utils/hocs/withAuth';
import withSidebar from '../../../utils/hocs/withSidebar';
import SCOPE from '../../../utils/gate/scope';
import withPermission from '../../../utils/hocs/withPermission';

// Components
import PageWrapper from '../../../components/layout/PageWrapper/PageWrapper';
import AccommodationsView from '../../../components/views/establishment/Products/Accommodations/Accommodations';

function Accommodations() {
  const { t } = useTranslation();

  return (
    <PageWrapper
      title={t('accommodations.title')}
      hasWhiteWrapper
    >
      <AccommodationsView />
    </PageWrapper>
  );
}

export default withAuth(
  withPermission(
    withSidebar(Accommodations),
    {
      scopes: [SCOPE.get_ownEst_accommodation],
    },
  ),
);
